module.exports = __webpack_public_path__ + "static/img/b.68e9173.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/b.png
// module id = ydrQ
// module chunks = 1